import { render, staticRenderFns } from "./Commission_Staff.vue?vue&type=template&id=6713cbe0&scoped=true&"
import script from "./Commission_Staff.vue?vue&type=script&lang=js&"
export * from "./Commission_Staff.vue?vue&type=script&lang=js&"
import style0 from "./Commission_Staff.vue?vue&type=style&index=0&id=6713cbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713cbe0",
  null
  
)

export default component.exports